module.exports = __webpack_public_path__ + "img/sendTopic.e17b44ff.png";